import { Controller } from "@hotwired/stimulus";
import Highcharts from "highcharts/highstock";
import HighchartsMoreFn from "highcharts/highcharts-more";
import HighchartsAccessibilityFn from "highcharts/modules/accessibility";
HighchartsMoreFn(Highcharts);
HighchartsAccessibilityFn(Highcharts);

// Connects to data-controller="collect"
export default class extends Controller {
  static targets = ["stockChart"];
  static values = {
    idFund: String,
    favoriteId: String,
    name: String,
    height: String,
    width: String,
  };

  connect() {
    this.createFavoriteStockChart();
  }

  async deleteFavoriteFund() {
    if (!confirm("該当お気に入りファンドを削除しますか？")) return;
    let url = "/fund/" + this.idFundValue + "/favorite/" + this.favoriteIdValue;
    await fetch(url, { 
        method: "DELETE",
        headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content') }
      })
      .then((Result) => Result.json())
      .then((data) => {
        if (data.status == "2") {
          let delete_nodes = document.querySelectorAll(
            "[data-id-fund = '" + this.idFundValue + "']"
          );
          // 因為後端刪除後 前端刪除 所以用這個方式 避免再reload整包data
          if (delete_nodes.length > 0) {
            delete_nodes.forEach((node) => {
              node.remove();
            });
          }
          // clear checked fund list in alpine js
          window.dispatchEvent(new CustomEvent("collect:delete_fund", { detail: { id: this.idFundValue } }));
          this.syncFavorite()
        } else if (data.status == -2) {
          return (window.location.href = "/login");
        } else {
          alert(data.msg);
        }
      })
      .catch((errorMsg) => {
        console.log(errorMsg);
      });
  }

  syncFavorite() {
    let allFavoriteButtons = document.querySelectorAll(`[data-controller="favorite"][data-favorite-id-fund-value="${this.idFundValue}"]`)
    allFavoriteButtons.forEach(el => { 
      el.setAttribute('data-favorite-id-value', '')
      el.dispatchEvent(new CustomEvent('favorite-deleted'))
    })
  }

  async createFavoriteStockChart() {
    let url = "/json/funds/" + this.idFundValue + "/get_line_daily_json";
    await fetch(url, { method: "GET" })
      .then((Result) => Result.json())
      .then((data) => {
        if (data) {
          this.drawStockChart(data);
        }
      })
      .catch((errorMsg) => {
        console.log(errorMsg);
      });
  }

  drawStockChart(data) {
    let dataSource = [];
    for (let i = data.data.length - 1; i >= 0; i--) {
      dataSource.push([data.data[i][0], data.data[i][1]]);
    }
    let seriesData = [
      {
        id: "prices",
        name: this.nameValue,
        type: "area",
        data: dataSource,
        color: "#3a93d4",
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#d9ecfd"],
            [1, Highcharts.color("#d9ecfd").setOpacity(0).get("rgba")],
          ],
        },
        threshold: null,
      },
    ];
    this.chart = Highcharts.setOptions({
      global: {
        useUTC: false, //关闭UTC
      },
      lang: {
        thousandsSep: ",",
        rangeSelectorZoom: "",
      },
    });
    if (this.hasStockChartTarget) {
      this.chart = Highcharts.stockChart(this.stockChartTarget, {
        chart: {
          width: this.widthValue,
          height: this.heightValue,
        },
        credits: {
          enabled: false,
        },
        rangeSelector: {
          enabled: false,
        },
        title: {
          text: null,
        },
        xAxis: {
          type: "datetime",
          dateTimeLabelFormats: {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%m/%d",
            day: "%m/%d",
            week: "%m/%d",
            month: "%m/%d",
            year: "%Y/%m",
          },
          tickAmount: 4,
          crosshair: {
            color: "#fec317",
            width: 1.5,
          },
          labels: {
            style: {
              color: "#666",
              fontSize: "0.6875rem",
            },
          },
        },
        yAxis: {
          labels: {
            formatter: function () {
              return Highcharts.numberFormat(this.value, 0);
            },
            style: {
              color: "#666",
              fontSize: "0.6875rem",
            },
          },
          tickAmount: 4,
          crosshair: {
            color: "#fec317",
            width: 1.5,
          },
          tickPositioner: function () {
            let positions = [],
              tick = Math.floor(this.dataMin),
              increment = Math.ceil((this.dataMax - this.dataMin) / 4);

            if (this.dataMax !== null && this.dataMin !== null) {
              for (tick; tick - increment <= this.dataMax; tick += increment) {
                positions.push(tick);
              }
            }
            return positions;
          },
        },
        tooltip: {
          xDateFormat: "%Y/%m/%d",
          headerFormat: "<b>{point.key}</b>",
          pointFormat: "<b>{point.y}</b>",
          backgroundColor: "#fec317",
        },
        plotOptions: {
          area: {
            tooltip: {
              split: false,
              headerFormatter: "{point.key}<br/>",
            },
          },
          candlestick: {
            tooltip: {
              headerFormatter: "{point.key}<br/>",
              pointFormat:
                '<span style="color:{point.color}">●</span><b> {series.name}</b><br/>' +
                "始値：{point.open}<br/>" +
                "高値：{point.high}<br/>" +
                "安値：{point.low}<br/>" +
                "終値：{point.close}<br/>",
            },
          },
          series: {
            dataGrouping: {
              enabled: false, // 关掉数据分组
            },
          },
        },
        navigator: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        series: seriesData,
      });
    }
  }
}
